import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "result__top" }
const _hoisted_2 = { class: "result__info" }
const _hoisted_3 = { class: "result__info-wrap" }
const _hoisted_4 = { class: "result__info-position" }
const _hoisted_5 = { class: "result__info-sinhro" }
const _hoisted_6 = { class: "result__info-value" }
const _hoisted_7 = { class: "result__info-line" }
const _hoisted_8 = { class: "result__top-wrap" }
const _hoisted_9 = { class: "result__content" }
const _hoisted_10 = { class: "result__middle" }
const _hoisted_11 = { class: "result__worlds" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "result__world-title" }
const _hoisted_14 = { class: "result__world-text" }
const _hoisted_15 = { class: "result__middle-right" }
const _hoisted_16 = { class: "result__create" }
const _hoisted_17 = { class: "result__create-wrap" }
const _hoisted_18 = { class: "result__create-subtitle" }
const _hoisted_19 = { class: "result__create-text" }
const _hoisted_20 = { class: "result__sinhro" }
const _hoisted_21 = {
  class: "result__sinhro-total",
  style: {"background":"url('/images/result-sinhro-total-bg.png') no-repeat"}
}
const _hoisted_22 = { class: "result__worth" }
const _hoisted_23 = { class: "result__worth-item" }
const _hoisted_24 = { class: "result__sinhro-subtitle" }
const _hoisted_25 = { class: "result__values" }
const _hoisted_26 = { class: "result__values-wrap" }
const _hoisted_27 = {
  class: "result__values-progress",
  style: {"background":"url('/images/result-values-progress-empty.svg')\n                      no-repeat"}
}
const _hoisted_28 = { class: "result__values-total" }
const _hoisted_29 = { class: "result__bottom" }
const _hoisted_30 = { class: "result__skills" }
const _hoisted_31 = { class: "result__image" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "advantages-modal__wrap" }
const _hoisted_34 = { class: "advantages-modal__content" }
const _hoisted_35 = { class: "advantages-modal__content-wrap" }
const _hoisted_36 = { class: "advantages-modal__items" }
const _hoisted_37 = { class: "advantages-modal__item-wrap" }
const _hoisted_38 = { class: "advantages-modal__item-image" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "advantages-modal__item-title" }
const _hoisted_41 = { class: "advantages-modal__content-wrap" }
const _hoisted_42 = { class: "advantages-modal__items advantages-modal__items--worth" }
const _hoisted_43 = { class: "advantages-modal__item-wrap" }
const _hoisted_44 = { class: "advantages-modal__item-image" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "advantages-modal__item-title" }
const _hoisted_47 = { class: "feedback__wrap" }
const _hoisted_48 = { class: "feedback__content" }
const _hoisted_49 = {
  key: 0,
  class: "feedback__items"
}
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "feedback__item-wrap" }
const _hoisted_52 = { class: "feedback__item-image" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "feedback__item-title" }
const _hoisted_55 = {
  key: 1,
  class: "feedback__items"
}
const _hoisted_56 = ["href"]
const _hoisted_57 = { class: "feedback__item-wrap" }
const _hoisted_58 = { class: "feedback__item-image" }
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "feedback__item-title" }

import { useRouter } from "vue-router";
import { useGameStore } from "@/stores/index";
import IntroButton from "./uikit/IntroButton.vue";
import UserPoints from "@/components/uikit/UserPoints.vue";
import InlineSvg from "@/components/uikit/InlineSvg.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { Navigation } from "swiper/modules";
import Cookies from "js-cookie";
import { computed, ref, onMounted } from "vue";
import { getImagePath } from "@/utils/image";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const starCount = 7;
const starWidth = 11;
const starMargin = 3;

export default /*@__PURE__*/_defineComponent({
  __name: 'ResultScreen',
  setup(__props) {

const store = useGameStore();
const router = useRouter();
const modules = [Navigation];
const pdfRef = ref<HTMLElement | null>(null);
const currentStars = computed(() => store.resultsList?.worthCount || 0);
const advantagesModal = ref(false);
const feedbackModal = ref(false);
const worthTitle = ref("");
const committeeInfo = ref(false);

const navigation = {
  nextEl: ".result__worth-next",
};

const navigation_worlds = {
  nextEl: ".result__worlds .slider-navigation__btn--next",
  prevEl: ".result__worlds .slider-navigation__btn--prev",
};

// Заполнение прогресс бара
const progressValue = computed(() => {
  const fullWidth = starCount * starWidth + (starCount - 1) * starMargin;
  const currentWidth =
    currentStars.value * starWidth +
    Math.max(currentStars.value - 1, 0) * starMargin;
  const maxWidth = (currentWidth / fullWidth) * 100;
  return maxWidth;
});

// Перезапуск игры
const repeatQuest = () => {
  Cookies.remove("user_id");
  router.push("/");
};

// Активность слайда при смене
const handleSlideChange = (swiper: any) => {
  const activeSlide = store.playerInfoArray?.selectedSkills[swiper.realIndex];
  if (activeSlide) {
    worthTitle.value = activeSlide.name;
  }
};

// Закрытие модалки обратная связь
const closeFeedbackModal = () => {
  feedbackModal.value = false;
  setTimeout(() => {
    committeeInfo.value = false;
  }, 300);
};

// Открытие модалки приемной комиссии
const openInspection = () => {
  committeeInfo.value = true;
  feedbackModal.value = true;
};

// Генерация PDF
const generatePdf = async () => {
  const doc = new jsPDF("landscape", "mm", "a4");
  const content = pdfRef.value;

  if (content) {
    html2canvas(content, { scale: 1 })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");

        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        const imgWidth = Math.min(pageWidth, canvas.width);
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const scaleFactor = Math.min(
          pageWidth / canvas.width,
          pageHeight / canvas.height
        );
        const finalWidth = canvas.width * scaleFactor;
        const finalHeight = canvas.height * scaleFactor;

        const offsetX = (pageWidth - finalWidth) / 2;
        const offsetY = (pageHeight - finalHeight) / 2;

        doc.addImage(imgData, "PNG", offsetX, offsetY, finalWidth, finalHeight);

        doc.save("result.pdf");
      })
      .catch((error) => {
        console.error("Ошибка при преобразовании в изображение:", error);
      });
  }
};

onMounted(() => {
  store.getResults();
  store.getContacts();
  store.getAchievements();
  store.getСommittee();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: "pdfTarget",
    class: "result",
    ref_key: "pdfRef",
    ref: pdfRef
  }, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "result__bg" }, [
      _createElementVNode("img", {
        src: "/images/result-bg.jpg",
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "result__info-logo" }, [
          _createElementVNode("img", {
            src: "/images/result-info-logo.svg",
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(store).playerInfoArray?.selectedCharacter?.name), 1),
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "result__info-title" }, "Синхронизация", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(store).resultsList?.totalScore) + "/100 ", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "result__info-line-current",
              style: _normalizeStyle('max-width: ' + _unref(store).resultsList?.totalScore + '%')
            }, null, 4)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(UserPoints, {
          count1: _unref(store).resultsList?.worthCount,
          count2: 5
        }, null, 8, ["count1"]),
        _createVNode(IntroButton, { onClick: repeatQuest }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("пройти заново "),
            _createElementVNode("img", {
              src: "/images/repeat-icon.svg",
              alt: ""
            }, null, -1)
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "result__content-decor result__content-decor--top-left" }, null, -1)),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "result__content-decor result__content-decor--top-right" }, null, -1)),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "result__content-decor result__content-decor--bottom-left" }, null, -1)),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "result__content-decor result__content-decor--bottom-right" }, null, -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(Swiper), {
            modules: modules,
            spaceBetween: 16,
            slidesPerView: 3,
            direction: 'vertical',
            navigation: navigation_worlds
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).resultsList?.studyAreas, (item, i) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "result__world",
                      href: item.link,
                      target: "_blank",
                      style: 'background: url(/images/result-worlds-bg.png) no-repeat'
                    }, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.code), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1)
                    ], 8, _hoisted_12)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "result__worlds-nav" }, [
            _createElementVNode("div", { class: "slider-navigation__btn slider-navigation__btn--prev" }),
            _createElementVNode("div", { class: "slider-navigation__btn slider-navigation__btn--next" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "result__create-title" }, "Командная миссия", -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(store).resultsList?.mission?.title), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(store).resultsList?.mission?.description), 1)
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "result__create-image" }, [
              _createElementVNode("img", {
                src: "/images/create-image.png",
                alt: ""
              })
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "result__create-line result__create-line--1" }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "result__create-line result__create-line--2" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "result__sinhro-bg" }, [
              _createElementVNode("img", {
                src: "/images/result-sinhro-bg.png",
                alt: ""
              })
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "result__sinhro-title" }, "СИНХРОНИЗАЦИЯ", -1)),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(store).resultsList?.totalScore), 1),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(Swiper), {
                slidesPerView: 4,
                modules: modules,
                navigation: navigation,
                spaceBetween: 8,
                loop: true,
                onSlideChange: handleSlideChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).playerInfoArray?.selectedSkills, (item, i) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(InlineSvg, {
                            src: '/images/' + item.icon + '.svg',
                            class: "my-custom-icon"
                          }, null, 8, ["src"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "result__worth-next" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_24, _toDisplayString(worthTitle.value), 1),
            _createElementVNode("div", _hoisted_25, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "result__values-title" }, "Открыто ценностей", -1)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: "result__values-progress-current",
                    style: _normalizeStyle([{"background":"url('/images/result-values-progress-full.svg')\n                        no-repeat"}, 'max-width: ' + progressValue.value + '%'])
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(store).resultsList?.worthCount) + "/" + _toDisplayString(_unref(store).resultsList?.totalWorthCount), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", {
          class: "result__inspection",
          onClick: openInspection
        }, _cache[15] || (_cache[15] = [
          _createStaticVNode("<div class=\"result__inspection-wrap\"><img src=\"/images/result-inspection-icon.svg\" alt=\"\"><span class=\"result__inspection-title\">Приемная комиссия</span><span class=\"result__inspection-text\">: Не стесняйся задать вопрос!</span></div><div class=\"result__inspection-count\">+1</div><div class=\"result__inspection-decor\"></div>", 3)
        ])),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", {
            class: "result__skills-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (advantagesModal.value = true))
          }, _cache[16] || (_cache[16] = [
            _createStaticVNode("<div class=\"result__skills-item-wrap\"><div class=\"result__skills-icon\"><img src=\"/images/result-skills-icon-1.svg\" alt=\"\"></div><div class=\"result__skills-text\">Достижения</div></div><div class=\"result__skills-tag\">НОВОЕ</div>", 2)
          ])),
          _createElementVNode("div", {
            class: "result__skills-item",
            onClick: generatePdf
          }, _cache[17] || (_cache[17] = [
            _createElementVNode("div", { class: "result__skills-item-wrap" }, [
              _createElementVNode("div", { class: "result__skills-icon" }, [
                _createElementVNode("img", {
                  src: "/images/result-skills-icon-2.svg",
                  alt: ""
                })
              ]),
              _createElementVNode("div", { class: "result__skills-text" }, "Скачать")
            ], -1)
          ]))
        ]),
        _createElementVNode("div", {
          class: "result__feedback",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (feedbackModal.value = true))
        }, _cache[18] || (_cache[18] = [
          _createElementVNode("img", {
            src: "/images/result-feedback-icon.svg",
            alt: ""
          }, null, -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("img", {
          src: 
            _unref(getImagePath)(_unref(store).playerInfoArray?.selectedCharacter?.imagePath)
          ,
          alt: ""
        }, null, 8, _hoisted_32)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["advantages-modal", { 'advantages-modal--active': advantagesModal.value }])
    }, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", {
          class: "advantages-modal__close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (advantagesModal.value = false))
        }),
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "advantages-modal__top" }, [
          _createElementVNode("div", { class: "advantages-modal__top-wrap" }, "Достижения")
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "advantages-modal__title" }, "Скиллы", -1)),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).achievementsList?.skills, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["advantages-modal__item", { 'advantages-modal__item--active': item.isActive }])
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("img", {
                        src: _unref(getImagePath)(item.icon),
                        alt: ""
                      }, null, 8, _hoisted_39)
                    ]),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(item.name), 1)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "advantages-modal__title" }, "ценности", -1)),
            _createElementVNode("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).achievementsList?.values, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["advantages-modal__item advantages-modal__item--worth", { 'advantages-modal__item--active': item.isActive }])
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("img", {
                        src: _unref(getImagePath)(item.icon),
                        alt: ""
                      }, null, 8, _hoisted_45)
                    ]),
                    _createElementVNode("div", _hoisted_46, _toDisplayString(item.name), 1)
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["feedback", { 'feedback--active': feedbackModal.value }])
    }, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", { class: "feedback__top" }, [
          _createElementVNode("div", {
            class: "feedback__back",
            onClick: closeFeedbackModal
          }, " Вернуться "),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "feedback__title" }, "Обратная связь", -1))
        ]),
        _createElementVNode("div", _hoisted_48, [
          (!committeeInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).contactsList, (item, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: i,
                    href: item.link,
                    target: "_blank",
                    class: "feedback__item"
                  }, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("img", {
                          src: _unref(getImagePath)(item.imagePath),
                          alt: ""
                        }, null, 8, _hoisted_53)
                      ]),
                      _createElementVNode("div", _hoisted_54, _toDisplayString(item.name), 1)
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "feedback__item-social" }, [
                      _createElementVNode("img", {
                        src: "/images/feedback-socilas-icon.svg",
                        alt: ""
                      })
                    ], -1))
                  ], 8, _hoisted_50))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (committeeInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("a", {
                  href: _unref(store).committeeList?.link,
                  target: "_blank",
                  class: "feedback__item"
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("img", {
                        src: _unref(getImagePath)(_unref(store).committeeList?.imagePath),
                        alt: ""
                      }, null, 8, _hoisted_59)
                    ]),
                    _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(store).committeeList?.name), 1)
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "feedback__item-social" }, [
                    _createElementVNode("img", {
                      src: "/images/feedback-socilas-icon.svg",
                      alt: ""
                    })
                  ], -1))
                ], 8, _hoisted_56)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ], 512))
}
}

})